/* eslint-disable import/prefer-default-export */
import numeral from 'numeral';

export const getCellFormat = (columnKey, cellValue) => {
  let value;
  let className = '';

  switch (columnKey) {
    case 'rank':
    case 'strategyRank': {
      value = cellValue;
      break;
    }
    case 'manager': {
      value = cellValue;
      className = 'manager';
      break;
    }
    case 'value': {
      value = numeral(cellValue).format('$0,0');
      break;
    }
    default:
      if (cellValue < 0) {
        className = 'negative';
      }
      value = numeral(cellValue).format('0.00%');
      break;
  }

  return { value, className };
};
